import { HandshakeIcon, Loader2, DollarSign } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { Label } from '../ui/label';
import {
  Dialog, DialogContent, DialogDescription, DialogHeader,
  DialogTitle, DialogFooter,
} from '../ui/dialog';

export function MakeOfferDialog({
  open, onOpenChange, selectedArtistForOffer,
  offerPrice, setOfferPrice, offerMessage, setOfferMessage,
  handleSubmitOffer, submittingOffer,
}) {
  const total = selectedArtistForOffer?.total || 0;
  const offer = parseFloat(offerPrice) || 0;
  const showSavings = selectedArtistForOffer && offer > 0 && offer < total;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-surface border-[#262626] max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <HandshakeIcon className="w-5 h-5 text-lime" />Make an Offer
          </DialogTitle>
          <DialogDescription>
            Negotiate a price for {selectedArtistForOffer?.items.length} dubplates from {selectedArtistForOffer?.artist_name}
          </DialogDescription>
        </DialogHeader>
        <div className="py-4 space-y-4">
          <div className="bg-[#1a1a1a] rounded-lg p-4">
            <div className="flex justify-between text-sm mb-2">
              <span className="text-[#A1A1AA]">Original Total:</span>
              <span className="line-through text-[#666]">${total.toFixed(2)}</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-[#A1A1AA]">Your Offer:</span>
              <div className="flex items-center gap-2">
                <DollarSign className="w-4 h-4 text-lime" />
                <Input
                  type="number"
                  value={offerPrice}
                  onChange={(e) => setOfferPrice(e.target.value)}
                  className="w-28 input-dark text-lg font-bold text-lime"
                  min="1"
                  step="0.01"
                  data-testid="offer-price-input"
                />
              </div>
            </div>
            {showSavings && (
              <p className="text-xs text-lime mt-2">
                You&rsquo;re saving ${(total - offer).toFixed(2)} ({Math.round((1 - offer / total) * 100)}% off)
              </p>
            )}
          </div>
          <div>
            <Label htmlFor="offer-message" className="text-sm text-[#A1A1AA]">Message (optional)</Label>
            <Textarea
              id="offer-message"
              value={offerMessage}
              onChange={(e) => setOfferMessage(e.target.value)}
              placeholder="Explain why you're making this offer..."
              className="input-dark mt-2"
              data-testid="offer-message-input"
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button
            onClick={handleSubmitOffer}
            disabled={submittingOffer || !offerPrice}
            className="btn-primary"
            data-testid="submit-offer-btn"
          >
            {submittingOffer ? <Loader2 className="w-4 h-4 animate-spin" /> : (<><HandshakeIcon className="w-4 h-4 mr-2" />Send Offer</>)}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
